import { AppSelect } from '../../ui/AppSelect';
import React from 'react';

const USER_STATS_RANGE_OPTIONS = [
  { key: 'today', label: '今日' },
  { key: '7d', label: '近 7 天' },
  { key: '30d', label: '近 30 天' },
  { key: 'all', label: '全部' },
  { key: 'custom', label: '自定义' },
];

const inputStyle = {
  backgroundColor: 'var(--color-bg-tertiary)',
  border: '1px solid var(--color-border-primary)',
  color: 'var(--color-text-primary)',
};

const UserStatsRangeControl = ({ rangeKey, onRangeChange, customRange, onCustomRangeChange, compact = false }) => (
  <div className="flex flex-wrap items-end gap-2">
    <div>
      <label className="text-label block mb-1.5">统计范围</label>
      <AppSelect
        value={rangeKey}
        onChange={(event) => onRangeChange(event.target.value)}
        className="h-8 px-2 rounded-md text-xs outline-none"
        style={inputStyle}
        aria-label="统计范围"
      >
        {USER_STATS_RANGE_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>{option.label}</option>
        ))}
      </AppSelect>
    </div>
    {rangeKey === 'custom' ? (
      <>
        <div>
          <label className="text-label block mb-1.5">开始日期</label>
          <input
            type="date"
            value={customRange.from}
            max={customRange.to || undefined}
            onChange={(event) => onCustomRangeChange({ ...customRange, from: event.target.value })}
            className="h-8 px-2 rounded-md text-xs outline-none"
            style={inputStyle}
          />
        </div>
        <div>
          <label className="text-label block mb-1.5">结束日期</label>
          <input
            type="date"
            value={customRange.to}
            min={customRange.from || undefined}
            onChange={(event) => onCustomRangeChange({ ...customRange, to: event.target.value })}
            className="h-8 px-2 rounded-md text-xs outline-none"
            style={inputStyle}
          />
        </div>
      </>
    ) : null}
    {!compact ? (
      <span className="pb-1 text-2xs" style={{ color: 'var(--color-text-muted)' }}>
        日期按北京时间自然日统计
      </span>
    ) : null}
  </div>
);

export default UserStatsRangeControl;
